export default "__VITE_ASSET__B5Qd$PqN__"